import { API_LIMIT_DATA } from '../utils/constants';
import * as actions from './constants';

const initialState = {
  classData: null,
  limit: API_LIMIT_DATA,
  offset: 1,
  classSubject: [],
  hasMore: false,
  selectedClass: {}
};

// eslint-disable-next-line consistent-return, default-param-last
export default function classesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SELECTED_CLASS:
      return {
        ...state,
        selectedClass: action.payload
      };
    case actions.ADD_CLASSES: {
      const newClasses = action.payload.classes;
      const existingClass = state.classData ? [...state.classData] : newClasses;
      if (state.classData) {
        newClasses.forEach((clas) => {
          const findExistingClassIndex = state.classData.findIndex((cd) => cd.id === clas.id);
          if (findExistingClassIndex === -1) {
            existingClass.push(clas);
          }
        });
      }
      return {
        ...state,
        classData: [...existingClass],
        offset: action.payload.offset,
        hasMore: action.payload.classes.length === API_LIMIT_DATA
      };
    }
    case actions.ADD_CLASS_SUBJECT:
      return {
        ...state,
        classSubject: action.payload
      };
    case actions.REPLACE_CLASSES:
      return {
        ...state,
        classData: action.payload.classes,
        offset: action.payload.offset,
        hasMore: action.payload.classes.length === API_LIMIT_DATA
      };
    case actions.CLASS_OPERATIONS:
      if (action.payload.action === 'add') {
        const newClasses = action.payload.classObj;
        const updatedData = state.classData ? [...state.classData] : [];
        const findExistingClassIndex = state.classData.findIndex(
          (cd) => cd.id === (newClasses?.id ?? newClasses?._id)
        );
        if (findExistingClassIndex === -1) {
          updatedData.push(newClasses);
        }
        return {
          ...state,
          classData: [...updatedData]
        };
      }

      if (action.payload.action === 'update') {
        const updatedObj = action.payload.classObj;
        const classIndex = state.classData.findIndex(
          (cd) => cd.id === (updatedObj?.id ?? updatedObj?._id)
        );
        state.classData[classIndex] = updatedObj;
        return {
          ...state,
          classData: state.classData
        };
      }

      if (action.payload.action === 'delete') {
        const updatedObj = action.payload.classObj;
        const classIndex = state.classData.findIndex(
          (cd) => cd.id === (updatedObj?.id ?? updatedObj?._id)
        );
        let newClasses = [];
        if (classIndex > -1) {
          newClasses = [
            ...state.classData.slice(0, classIndex),
            ...state.classData.slice(classIndex + 1)
          ];

          return {
            ...state,
            classData: newClasses
          };
        }
        return {
          ...state,
          classData: state.classData
        };
      }
      break;
    case actions.RESET_STATE:
      return {
        classData: null,
        limit: API_LIMIT_DATA,
        offset: 1,
        classSubject: [],
        hasMore: false
      };
    default:
      return state;
  }
}
